<template lang="pug">
  .column.middle.center.m-top-4
    .column.middle.center(v-if='!hasDrafts')
      img(:src='emptyImg' width='350px')
      h2.title-medium.dark-gray {{ type === "published" ? $t("krea.emptyContentList.emptyPublishedListTitle") : $t("krea.emptyContentList.emptyDraftsListTitle") }}
      router-link.m-top-2(v-if='hasKreaAccess' :to='{name: routes.kreaCreateEducationalContent}')
        button.primary-button {{ $t("krea.emptyContentList.createContent") }}
    .column.middle.center(v-else)
      img.m-bottom-3(:src='hasDraftsImg' width='350px')
      h2.title-medium.dark-gray {{ $t("krea.emptyContentList.hasDraftsListTitle") }}
      router-link.m-top-2(:to='{name: routes.kreaDrafts}')
        button.primary-button {{ $t("krea.emptyContentList.resumeEdition") }}
</template>

<script>
import { routes } from '@/router'
import emptyImg from '@/assets/ic_noresults.svg'
import hasDraftsImg from '@/assets/il_trial_timeover.svg'
import kreaRoles from '@/mixins/kreaRoles'

export default {
  props: {
    type: { type: String },
    hasDrafts: { type: [Boolean, Number] }
  },
  mixins: [kreaRoles],
  data() {
    return {
      routes,
      hasDraftsImg,
      emptyImg
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
